import Toggle from 'components/Toggle'
import cx from 'classnames'

import style from './style.styl'

const ToggleSection = ({ title, description, isActive, onToggled, className }) => (
  <div className={cx("shared-toggle-section", className)}>
    <div>
      <span className="shared-toggle-section-title">
        {title}
      </span>
      <span className="shared-toggle-section-description">
        {description}
      </span>
    </div>
    <Toggle
      className="shared-toggle-section-toggle"
      checked={isActive}
      onChange={onToggled} />
  </div>
)

export default ToggleSection



// WEBPACK FOOTER //
// ./src/scripts/components/shared/ToggleSection/index.js